
import { animate } from 'animejs';
import $ from '../libs/jquery';
import globalVar from '../utils/globalVar'
import utils from '../utils/utils'
import { App } from '../app';



class Ajax {
  constructor() {
    let cache = {};
    const getUrl = window.location;
    const getUrlHref = getUrl.href;
    let baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0];
    const liens = [];
    let initFunc = () => {
      initCache();
      registerEvents();
      // loader();
    }

    let initCache = () => {
      cache.dropdown = document.querySelectorAll('.module-13-content_dropdown .dropdown_title');
      cache.loader = document.querySelector('.loader');
      // cache.loaderRect = cache.loader.querySelectorAll('.rect');
      // cache.transition = document.querySelector('.transition');
      // cache.transitionRect = cache.transition.querySelectorAll('.rect');
      if (baseUrl != null && baseUrl.length > 0 && baseUrl.charAt(baseUrl.length - 1) == '/') {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1);
      }
    };

    let registerEvents = () => {
      const link = document.querySelectorAll('a[href*="'+baseUrl+'"]');

      for (let i = 0; i < link.length; i++) {
        if(!link[i].classList.contains('no_ajax')) {
          link[i].addEventListener("click", ajaxNav);
        }
      }
      window.addEventListener('popstate',back);
    };

    let ajaxNav = function(event) {
      utils.disableScroll();
      event.preventDefault();
      const href = this.href;
      // cache.transition.style.display = "block";
      // historyIndex++;
      // if(!proNext) {
      //   anime({
      //     targets: cache.transitionRect[0],
      //     translateY: ['100%','-100%'],
      //     duration: 800,
      //     easing: 'easeInCirc',
      //   });
      //   anime({
      //     targets: cache.transitionRect[1],
      //     translateY: ['100%','0%'],
      //     delay: 400,
      //     duration: 400,
      //     easing: 'easeInCirc',
      //   });
      // }
      setTimeout(function(){ ajaxFunc(href); }, 300);
      history.pushState(null, null, href);
    }

    let back = function(event) {
      utils.disableScroll();
      event.preventDefault();
      var href = this.href;
      // cache.transition.style.display = "block";
      // historyIndex++;
      // anime({
      //   targets: cache.transitionRect[0],
      //   translateY: ['100%','-100%'],
      //   duration: 800,
      //   easing: 'easeInCirc',
      // });
      // anime({
      //   targets: cache.transitionRect[1],
      //   translateY: ['100%','0%'],
      //   delay: 400,
      //   duration: 400,
      //   easing: 'easeInCirc',
      // });
      setTimeout(function(){ ajaxFunc(href); }, 300);
    }

    let ajaxFunc = function(url) {
      console.log(url);
      const link = document.querySelectorAll('a[href*="'+baseUrl+'"]');
      for (let i = 0; i < link.length; i++) {
        if(!link[i].classList.contains('no_ajax')) {
          link[i].removeEventListener("click", ajaxNav);
        }
      }
      // window.removeEventListener('scroll', animePage);

      $.ajax({
        url: url,
        cache: false,
        success: function(data){
        // callback
        const title = $(data).filter('title').text();
          // document.title = title;
          // const contenu = $('div#contenu', data);
          // const head = $($.parseHTML(data)).find("head");
          // const footer = $('footer', data);
          // const header = $('#nav_header', data);
          // let parser = new DOMParser();
          // let doc = parser.parseFromString(data, "text/html");
          // const docClass = doc.body.getAttribute('class');
          // parser = doc = null;

//           var mySubString = data.substring(
//               data.indexOf("<head>") + 1,
//               str.lastIndexOf("</head>")
//           );
// console.log(mySubString);

          $('#contenu').fadeOut('100',function(){
            document.documentElement.innerHTML = data;
            // $('body').addClass(docClass);
            // $('head').html(head.html());
            // $('footer').html(footer.html());
            // $('#nav_header').html(header.html());
            // console.log($($.parseHTML(data)).find('div#contenu'));
            // $('#contenu').html(contenu.html()).fadeIn('0');

            window.scrollTo(0, 0);
            utils.enableScroll();
            window.removeEventListener('popstate',back);
            let app = new App();
            // const CurrentObject = window["app"];
            // console.log(window);
            // const app = new CurrentObject();

            // if(!proNext) {
              // anime({
              //   targets: cache.transitionRect[1],
              //   translateY: ['0%','-100%'],
              //   duration: 400,
              //   easing: 'easeOutCirc',
              // });
              // cache.nav.style.top = '-80px';
              // anime({
              //   targets: cache.transitionRect[0],
              //   translateY: ['100%','-100%'],
              //   duration: 800,
              //   delay: 0,
              //   easing: 'easeOutCirc',
              //   complete: function() {
              //     cache.transition.style.display = "none";
              //     colorsArray = shuffle(colorsArray);
              //     cache.transitionRect[0].classList = "rect bg-"+colorsArray[0];
              //     cache.transitionRect[1].classList = "rect bg-"+colorsArray[1];
              //     headerDown = true;
              //     anime({
              //       targets: cache.nav,
              //       top: [-80, 0],
              //       duration: 600,
              //       easing: 'easeOutQuad',
              //     });
              //   }
              // });
            // } else {
            //   proNext = false;
            //   cache.transition.style.display = "none";
            //   var imgT = document.querySelector('.img_fix');
            //   anime({
            //     targets: document.querySelector('#contenu'),
            //     marginTop: ['30%','0%'],
            //     duration: 500,
            //     easing: 'linear',
            //   });
            //   anime({
            //     targets: imgT,
            //     translateY: '-150%',
            //     duration: 500,
            //     easing: 'linear',
            //     complete: function() {
            //       imgT.remove();
            //       headerDown = true;
            //       anime({
            //         targets: cache.nav,
            //         top: [-80, 0],
            //         duration: 600,
            //         easing: 'easeOutQuad',
            //       });
            //     }
            //   });
            // }
          });
        }
      });
    }
    

    initFunc();
  };
}
export { Ajax }

//   var loader = function() {

// var ii = 0;
//     for (var i = 0; i < cache.logo.length; i++) {
//       anime({
//         targets: cache.logo[i],
//         opacity: 1,
//         translateY: ['106%','0%'],
//         opacity:[0,1],
//         skewX: [-50, 0],
//         skewY: [-10, 0],
//         delay: (1000 + (60 * i)),
//         duration: 800,
//         easing: 'easeOutExpo',
//         complete: function() {
//           if(ii == cache.logo.length-1) {
//             ii++;
//             anime({
//               targets: this['animatables'][0]['target'],
//               opacity: 0,
//               duration: 300,
//               easing: 'easeOutExpo'
//             });
//           } else {
//             removeLoader();
//           }
//         }
//       });
//     }

//   }

//   var removeLoader = function(e) {
//     loaderHome = false;
//     anime({
//       targets: cache.loader.querySelector('.inner'),
//       opacity: 0,
//       delay: 2500,
//       duration: 100,
//       easing: 'easeOutCirc',
//     });
//     anime({
//       targets: cache.loaderRect[0],
//       translateY: ['100%','-100%'],
//       delay: 2000,
//       duration: 1000,
//       easing: 'easeInOutCirc',
//     });
//     anime({
//       targets: cache.loaderRect[1],
//       translateY: ['100%','-100%'],
//       delay: 2100,
//       duration: 1000,
//       easing: 'easeInOutCirc',
//       complete: function() {
//         cache.loader.remove();
//         enableScroll();
//       }
//     });
//   }

//   var ajaxNav = function() {
//     disableScroll();
//     event.preventDefault();
//     var href = this.href;
//     cache.transition.style.display = "block";
//     // historyIndex++;
//     if(!proNext) {
//       anime({
//         targets: cache.transitionRect[0],
//         translateY: ['100%','-100%'],
//         duration: 800,
//         easing: 'easeInCirc',
//       });
//       anime({
//         targets: cache.transitionRect[1],
//         translateY: ['100%','0%'],
//         delay: 400,
//         duration: 400,
//         easing: 'easeInCirc',
//       });
//     }
//     setTimeout(function(){ ajaxFunc(href); }, 300);
//     history.pushState(null, null, href);
//   }



//   var back = function(e) {
//     disableScroll();
//     event.preventDefault();
//     var href = this.href;
//     cache.transition.style.display = "block";
//     // historyIndex++;
//     anime({
//       targets: cache.transitionRect[0],
//       translateY: ['100%','-100%'],
//       duration: 800,
//       easing: 'easeInCirc',
//     });
//     anime({
//       targets: cache.transitionRect[1],
//       translateY: ['100%','0%'],
//       delay: 400,
//       duration: 400,
//       easing: 'easeInCirc',
//     });
//     setTimeout(function(){ ajaxFunc(href); }, 300);
//   }

//   var ajaxFunc = function(url) {
//       var link = document.querySelectorAll('a[href*="'+baseUrl+'"]');
//       for (var i = 0; i < link.length; i++) {
//         if(!link[i].classList.contains('no_ajax')) {
//           link[i].removeEventListener("click", ajaxNav);
//         }
//       }
//       cancelAnimationFrame(secInsta);
//       window.removeEventListener('scroll', animePage);

//       $.ajax({
//         url: url,
//         cache: false,
//         success: function(data){
//         // callback
//         var title = $(data).filter('title').text();
//           document.title = title;
//           var contenu = $('div#contenu', data);
//           var head = $($.parseHTML(data)).find("head");
//           var footer = $('footer', data);
//           var header = $('#nav_header', data);
//           var parser = new DOMParser();
//           doc = parser.parseFromString(data, "text/html");
//           var docClass = doc.body.getAttribute('class');
//           parser = doc = null;

// //           var mySubString = data.substring(
// //               data.indexOf("<head>") + 1,
// //               str.lastIndexOf("</head>")
// //           );
// // console.log(mySubString);

//           $('#contenu').fadeOut('100',function(){
//             $('body').removeClass();
//             $('body').addClass(docClass);
//             $('head').html(head.html());
//             $('footer').html(footer.html());
//             $('#nav_header').html(header.html());
//             $(this).html(contenu.html()).fadeIn('0');

//             window.scrollTo(0, 0);
//             enableScroll();
//             window.removeEventListener('popstate',back);

//             CurrentObject = window["App"];
//             var app = new CurrentObject();

//             if(document.querySelector('.sticker_container .sticker')) {
//               var sticker = document.querySelectorAll('.sticker_container .sticker');
//               for (var i = 0; i < sticker.length; i++) {
//                 sticker[i].remove();
//               }
//             }

//             nbSticker = 0;

//             if(!proNext) {
//               anime({
//                 targets: cache.transitionRect[1],
//                 translateY: ['0%','-100%'],
//                 duration: 400,
//                 easing: 'easeOutCirc',
//               });
//               cache.nav.style.top = '-80px';
//               anime({
//                 targets: cache.transitionRect[0],
//                 translateY: ['100%','-100%'],
//                 duration: 800,
//                 delay: 0,
//                 easing: 'easeOutCirc',
//                 complete: function() {
//                   cache.transition.style.display = "none";
//                   colorsArray = shuffle(colorsArray);
//                   cache.transitionRect[0].classList = "rect bg-"+colorsArray[0];
//                   cache.transitionRect[1].classList = "rect bg-"+colorsArray[1];
//                   headerDown = true;
//                   anime({
//                     targets: cache.nav,
//                     top: [-80, 0],
//                     duration: 600,
//                     easing: 'easeOutQuad',
//                   });
//                 }
//               });
//             } else {
//               proNext = false;
//               cache.transition.style.display = "none";
//               var imgT = document.querySelector('.img_fix');
//               anime({
//                 targets: document.querySelector('#contenu'),
//                 marginTop: ['30%','0%'],
//                 duration: 500,
//                 easing: 'linear',
//               });
//               anime({
//                 targets: imgT,
//                 translateY: '-150%',
//                 duration: 500,
//                 easing: 'linear',
//                 complete: function() {
//                   imgT.remove();
//                   headerDown = true;
//                   anime({
//                     targets: cache.nav,
//                     top: [-80, 0],
//                     duration: 600,
//                     easing: 'easeOutQuad',
//                   });
//                 }
//               });
//             }
//           });
//         }
//       });
//     }


//   // Utils
//    function preventDefault(e) {
//        e = e || window.event;
//        if (e.preventDefault)
//            e.preventDefault();
//        e.returnValue = false;
//      }
//    function preventDefaultForScrollKeys(e) {
//          if (keys[e.keyCode]) {
//              preventDefault(e);
//              return false;
//          }
//      }

//      function disableScroll() {
//        if (window.addEventListener) // older FF
//            window.addEventListener('DOMMouseScroll', preventDefault, false);
//            document.addEventListener('wheel', preventDefault, {passive: false}); // Disable scrolling in Chrome
//            window.addEventListener("keydown", arrow_keys_handler, false);
//            document.querySelector('html').classList.add('overflow');
//            document.querySelector('body').classList.add('overflow');
//      }

//      function enableScroll() {
//          if (window.removeEventListener)
//              window.removeEventListener('DOMMouseScroll', preventDefault, false);
//          document.removeEventListener('wheel', preventDefault, {passive: false}); // Enable scrolling in Chrome
//          window.onmousewheel = document.onmousewheel = null;
//          window.onwheel = null;
//          window.ontouchmove = null;
//          document.onkeydown = null;
//          window.removeEventListener("keydown", arrow_keys_handler, false);
//          document.querySelector('html').classList.remove('overflow');
//          document.querySelector('body').classList.remove('overflow');
//      }

//      var arrow_keys_handler = function(e) {
//        switch(e.keyCode){
//          case 37: case 39: case 38:  case 40: // Arrow keys
//          case 32: e.preventDefault(); break; // Space
//          default: break; // do not block other keys
//        }
//      };

//      function shuffle(array) {
//        var currentIndex = array.length,  randomIndex;

//        // While there remain elements to shuffle...
//        while (currentIndex != 0) {

//          // Pick a remaining element...
//          randomIndex = Math.floor(Math.random() * currentIndex);
//          currentIndex--;

//          // And swap it with the current element.
//          [array[currentIndex], array[randomIndex]] = [
//            array[randomIndex], array[currentIndex]];
//        }

//        return array;
//      }

//   init();
// };
